module.exports = __webpack_public_path__ + "media/images/share-3588446e94b26da6be12f61e2b863c5a.png";